import React from 'react';
import pluralize from 'pluralize';
import { START } from 'shared/data/quoteSteps';

import HowItWorks from 'shared/product_tabs/tab_assembly/components/HowItWorks';
import PriceMatrix from 'shared/components/price/PriceMatrix';

const PriceMX = (props) => {
  const {
    quote,
    quoteStep,
    parametersChanged,
    onPriceSelect,
    parameters,
  } = props;

  const lineItem = quote.line_items.find((i) => i.product_key === 'assembly-mx');
  const { restricted_price } = lineItem;

  return (
    <div className="price-mx">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-uppercase mb-0">Mexico PCB Assembly</h2>
      </div>
      <div className="row">
        <div className="col-12">
          <PriceMatrix
            leadTimeText={(lt) => `${pluralize('week', lt)}`}
            tableStripe
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep}
            restrictedPrice={restricted_price} />
        </div>
        <div>
          <ul>
            <li>First Article cost is included (Lead Time = 2 to 3 weeks).</li>
            <li>Production Lead Time starts after First Article is approved.</li>
            <li>To return the leftover parts and SMT Stencil, an additional customs fee (~$500.00) will be applied.</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <HowItWorks />
      </div>
    </div>
  );
};

export default PriceMX;
